/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { ICollectionSubtitle } from '../collection-subtitle-schema';
import { collectionSubtitleSchema } from '../collection-subtitle-schema';

export const createCollectionSubtitleResponseSchema = createApiResponseSchema(
  collectionSubtitleSchema,
) as import('zod').ZodSchema<IAPI<ICollectionSubtitle>>;

export type ICreateCollectionSubtitleResponse = IAPI<ICollectionSubtitle>;
